<template><DatasetFormEditor form-name="modifyDatasetForm" modification /></template>
<script>
import DatasetFormEditor from "./DatasetFormEditor.vue";
export default { name: "ModifyDatasetForm", components: { DatasetFormEditor } };
</script>
